"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _root = _interopRequireDefault(require("./style/simple/root"));

var _textWrapper = _interopRequireDefault(require("./style/simple/textWrapper"));

var _balance = _interopRequireDefault(require("./style/simple/balance"));

var _currency = _interopRequireDefault(require("./style/simple/currency"));

var _number = _interopRequireDefault(require("./style/simple/number"));

var _name = _interopRequireDefault(require("./style/simple/name"));

var _issuer = _interopRequireDefault(require("./style/simple/issuer"));

var CardItem = function CardItem(_ref) {
  var IssuerIcon = _ref.imgIssuer,
      balance = _ref.balance,
      name = _ref.name,
      number = _ref.number,
      currency = _ref.currency,
      theme = _ref.theme,
      selected = _ref.selected,
      disabled = _ref.disabled;
  return _react["default"].createElement(_root["default"], {
    theme: theme,
    selected: selected,
    disabled: disabled,
    title: name + ' ' + number
  }, _react["default"].createElement(_textWrapper["default"], {
    theme: theme,
    issuer: !!IssuerIcon
  }, _react["default"].createElement("span", null, balance !== null ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_balance["default"], {
    theme: theme,
    selected: selected,
    disabled: disabled
  }, balance), _react["default"].createElement(_currency["default"], {
    theme: theme,
    selected: selected,
    disabled: disabled
  }, currency)) : null, _react["default"].createElement(_number["default"], {
    theme: theme,
    selected: selected,
    disabled: disabled
  }, number), _react["default"].createElement(_name["default"], {
    theme: theme,
    selected: selected,
    disabled: disabled
  }, name))), _react["default"].createElement(_issuer["default"], null, IssuerIcon ? _react["default"].createElement(IssuerIcon, null) : null));
};

CardItem.propTypes = {
  balance: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  number: _propTypes["default"].string,
  name: _propTypes["default"].string,
  currency: _propTypes["default"].string,
  imgIssuer: _propTypes["default"].any,
  theme: _propTypes["default"].object
};

var _default = _react["default"].memo(CardItem);

exports["default"] = _default;